// This function allow to reference chunks
__webpack_require__.u = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "js/" + chunkId + "-" + {935: "de7444f2f5accfad",9651: "230e05af815f527d",}[chunkId] + ".js"
}